(() => {
  if (window.customerReviewsInitialized) return;
  window.customerReviewsInitialized = true;

  const expandedClass = 'customer-reviews__text--expanded';

  const refreshToggle = (button) => {
    const contentId = button.getAttribute('aria-controls');
    const content = contentId ? document.getElementById(contentId) : null;
    if (!content || content.classList.contains(expandedClass)) return;

    button.hidden = content.scrollHeight <= content.clientHeight + 1;
  };

  const refreshToggles = (root = document) => {
    root.querySelectorAll('[data-review-toggle]').forEach((button) => {
      window.requestAnimationFrame(() => refreshToggle(button));
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-review-toggle]');
    if (!button) return;

    const contentId = button.getAttribute('aria-controls');
    const content = contentId ? document.getElementById(contentId) : null;
    if (!content) return;

    const expanded = button.getAttribute('aria-expanded') === 'true';
    content.classList.toggle(expandedClass, !expanded);
    button.setAttribute('aria-expanded', String(!expanded));
    button.textContent = expanded ? 'Show more' : 'Show less';
  });

  document.addEventListener('DOMContentLoaded', () => refreshToggles());
  document.addEventListener('shopify:section:load', (event) => refreshToggles(event.target));

  let resizeFrame;
  window.addEventListener('resize', () => {
    window.cancelAnimationFrame(resizeFrame);
    resizeFrame = window.requestAnimationFrame(() => refreshToggles());
  });
})();
